import React from 'react';
import { SYSTEM_COLORS } from '../../constants/brandPalette';

const ModalOverlay = ({ isOpen, onClose, children, closeOnOverlayClick = false, zIndex = 50 }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && onClose && e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{ zIndex, backgroundColor: SYSTEM_COLORS.shellOverlay }}
      onClick={handleOverlayClick}
    >
      {children}
    </div>
  );
};

export default ModalOverlay;
